import { UseFormReturn } from 'react-hook-form'

import { SwapFormFields } from '../../types'
import { SwapFormSchema } from './schema'
import { TokenWithBalance } from '@/domain/common/types'
import { TokenRepository } from '@/domain/token-repository/TokenRepository'
import { TokenSymbol } from '@/domain/types/TokenSymbol'

export interface GetSwapFormFieldsParams {
  form: UseFormReturn<SwapFormSchema>
  tokenRepository: TokenRepository
  psmStables: TokenSymbol[]
}
export function getSwapFormFields({ form, tokenRepository, psmStables }: GetSwapFormFieldsParams): SwapFormFields {
  const { from, to } = form.watch()
  const selectedAssetIn = tokenRepository.findOneBySymbol(from)
  const selectedAssetOut = tokenRepository.findOneBySymbol(to)

  const allStablesWithBalance: TokenWithBalance[] = psmStables
    .map((symbol) => {
      const token = tokenRepository.findBySymbol(symbol)
      if (!token) return undefined
      return { token, balance: tokenRepository.findOneBalanceOrZero(symbol) }
    })
    .filter(Boolean)
  const assetInOptions = allStablesWithBalance.filter(({ token }) => token.symbol !== selectedAssetIn.symbol)
  const assetOutOptions = allStablesWithBalance.filter(
    ({ token }) => token.symbol !== selectedAssetOut.symbol && token.symbol !== selectedAssetIn.symbol,
  )

  function changeAssetIn(newSymbol: TokenSymbol): void {
    if (newSymbol === to) {
      form.setValue('to', from)
    }
    form.setValue('from', newSymbol)
    form.setValue('amount', '')
    form.setValue('isMaxSelected', false)
    form.clearErrors()
  }

  function changeAssetOut(newSymbol: TokenSymbol): void {
    form.setValue('to', newSymbol)
    form.clearErrors()
  }

  function swapAssets(): void {
    form.setValue('from', to)
    form.setValue('to', from)
    form.setValue('amount', '')
    form.setValue('isMaxSelected', false)
    form.clearErrors()
  }

  return {
    selectedAssetIn,
    selectedAssetInBalance: tokenRepository.findOneBalanceOrZero(selectedAssetIn.symbol),
    selectedAssetOut,
    assetInOptions,
    assetOutOptions,
    changeAssetIn,
    changeAssetOut,
    swapAssets,
    maxSelectedFieldName: 'isMaxSelected',
  }
}
